var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLinkOnly)?_c('a',{staticClass:"expo-btn expo-btn-white",attrs:{"title":_vm.title}},[_vm._t("default")],2):_c('a',{staticClass:"expo-btn expo-btn-white",attrs:{"title":_vm.title},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }